// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.mole[data-v-0795c107] {

    margin-left: -5rem
}
.mole[data-v-0795c107]:not(:last-of-type) {

    margin-right: 10rem
}
.sm.mole[data-v-0795c107]:not(:last-of-type) {

    margin-right: 5rem
}
.md.mole[data-v-0795c107]:not(:last-of-type) {

    margin-right: 6rem
}
.mole.reversed[data-v-0795c107] {

    margin-left: 0 !important;

    margin-right: 0 !important;

    --tw-rotate: 180deg;

    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

    align-self: flex-start
}
.mole.reversed.vertical[data-v-0795c107] {

    margin-left: 4rem !important;

    --tw-rotate: -90deg;

    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
.mole.vertical[data-v-0795c107] {

    margin-right: 4rem !important;

    --tw-rotate: 90deg;

    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
.lg.mole[data-v-0795c107] {

    margin-left: -12.5rem
}
.xl.mole[data-v-0795c107] {

    margin-left: -20rem
}
.xxl.mole[data-v-0795c107] {

    margin-left: -30rem
}
.mole path[data-v-0795c107] {

    opacity: 0.4
}
.warning.mole path[data-v-0795c107] {

    fill: #F9EDC4
}
.info.mole path[data-v-0795c107] {

    fill: #81C5EE
}
.error.mole path[data-v-0795c107] {

    fill: #FFB29D
}
.success.mole path[data-v-0795c107] {

    fill: #68EA9C
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/components/layout/Mole.vue"],"names":[],"mappings":";AAoDA;;IAAA;AAAA;AAGA;;IAAA;AAAA;AAGA;;IAAA;AAAA;AAGA;;IAAA;AAAA;AAKA;;IAAA,yBAAA;;IAAA,0BAAA;;IAAA,mBAAA;;IAAA,+LAAA;;IAAA;AAAA;AAGA;;IAAA,4BAAA;;IAAA,mBAAA;;IAAA;AAAA;AAIA;;IAAA,6BAAA;;IAAA,kBAAA;;IAAA;AAAA;AAIA;;IAAA;AAAA;AAGA;;IAAA;AAAA;AAGA;;IAAA;AAAA;AAIA;;IAAA;AAAA;AAGA;;IAAA;AAAA;AAGA;;IAAA;AAAA;AAGA;;IAAA;AAAA;AAGA;;IAAA;AAAA","sourcesContent":["<template>\n  <svg\n    class=\"mole\"\n    :class=\"[type, spacing, { reversed, vertical }]\"\n    :width=\"width\"\n    viewBox=\"0 0 281 165\"\n    fill=\"none\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    preserveAspectRatio=\"none\"\n  >\n    <path\n      d=\"M149.133 164.891L0 164.891L161.856 19.0844C189.865 -6.14818 232.728 -5.03101 259.386 21.6264C289.141 51.3815 286.56 100.359 253.843 126.823L206.777 164.891L149.133 164.891Z\"\n    />\n  </svg>\n</template>\n\n<script>\nimport { computed } from '@vue/composition-api';\n\nexport default {\n  props: {\n    type: {\n      type: String,\n      default: 'warning',\n    },\n    reversed: {\n      type: Boolean,\n      default: false,\n    },\n    spacing: {\n      type: String,\n      default: 'sm',\n    },\n    scale: {\n      type: Number,\n      default: 1,\n    },\n    vertical: {\n      type: Boolean,\n      default: false,\n    },\n  },\n  setup(props) {\n    return {\n      width: computed(() => 281 * props.scale),\n    };\n  },\n};\n</script>\n\n<style lang=\"postcss\" scoped>\n.mole {\n  @apply -ml-xxl;\n\n  &:not(:last-of-type) {\n    @apply mr-huge;\n\n    .sm& {\n      @apply mr-xxl;\n    }\n    .md& {\n      @apply mr-[6rem];\n    }\n  }\n\n  &.reversed {\n    @apply !mx-0 self-start rotate-180 ;\n\n    &.vertical {\n      @apply -rotate-90 !ml-xl;\n    }\n  }\n  &.vertical {\n    @apply rotate-90 !mr-xl;\n  }\n\n  .lg& {\n    @apply -ml-giant;\n  }\n  .xl& {\n    @apply -ml-[20rem];\n  }\n  .xxl& {\n    @apply -ml-[30rem];\n  }\n\n  path {\n    @apply opacity-40;\n\n    .warning& {\n      @apply fill-feedback-alert-light;\n    }\n    .info& {\n      @apply fill-support-medium;\n    }\n    .error& {\n      @apply fill-feedback-error-lightest;\n    }\n    .success& {\n      @apply fill-feedback-success-light;\n    }\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
